import { Injectable } from '@angular/core';
import { StorageService } from './../Storage/storage.service';
import { WebTrendsObject } from './WebTrendsObject';
import { EntryEnum } from '../../models/flow/entry-enum';


declare var WebTrends: any;

export interface WebTrendsActionData {
  action: string, //1
  errormsg_desc?: string | null | undefined,//2
  stage_status?: number,//3
  errorMsg?: number,//4
  phone_number?: string,//5
  id_number?: string,//6
  HativaPratit?: string,//7
  verification_mode?: string,
  fullName?: string,
  email?: string,
  city?: string,
  street?: string,
  street_number?: string,
  x_param?: string,
  x_param_name?: string,
  vas?: string,
  amount?: string,
  locationֹ?: string,
  // stage_code?: string,
}

@Injectable({
  providedIn: 'root'
})
export class WebtrendsService {

  private _stageValue: string;
  public get stageValue(): string {
    return this._stageValue;
  }
  public set stageValue(value: string) {
    this._stageValue = value;
  }

  private _tag: any;

  constructor(private storageService: StorageService) {

    const _webTrendsLoaded = (typeof WebTrends !== 'undefined');
    if (_webTrendsLoaded) {
      if (!this._tag) {
        this._tag = new WebTrends();
        this._tag.dcsGetId();
        this._tag.dcsCollect();
        window['_tag'] = this._tag;
      }
    }
  }

  sendBackClickWebTrends(idNumber: string) {
    const action = 'ISP_PASS_back_clicked';
    this.sendWebTrends({
      action,
      id_number: idNumber,
    });
  }

  sendOnLoadWebTrends(action: string, idNumber: string, HativaPratit: string) {
    this.sendWebTrends({
      action,
      stage_status: 1,
      errorMsg: 0,
      id_number: idNumber,
      HativaPratit
    });
  }
  sendOnLoadWithErrorWebTrends(action: string, error: string, idNumber: string, HativaPratit: string) {
    this.sendWebTrends({
      action,
      errormsg_desc: error,
      stage_status: 0,
      errorMsg: 1
    });
  }
  sendWebTrends(data: WebTrendsActionData) {
    const webTrends = new WebTrendsObject(data.action);

    switch (this.storageService.getEntry()) {
      case EntryEnum.IspBzkPass: {
        webTrends.appid_av = 'ISP_PASS_RESET';
        webTrends.appid = 'ISP_PASS_RESET';
        webTrends.TI = 'ISP_PASS_RESET';
        webTrends.new_cust_ind = 1;
        break;
      }
      case EntryEnum.NewBan: {
        webTrends.appid_av = 'self sale - internet new customer';
        webTrends.appid = 'self sale - internet new customer';
        webTrends.TI = 'self sale - internet new customer';
        webTrends.new_cust_ind = 0;
        break;
      }
      case EntryEnum.ExistBan: {
        webTrends.appid_av = 'self sale - internet exist customer';
        webTrends.appid = 'self sale - internet exist customer';
        webTrends.TI = 'self sale - internet exist customer';
        webTrends.new_cust_ind = 1;
        break;
      }
      case EntryEnum.NewPack: {
        webTrends.appid_av = 'self sale - internet new pack';
        webTrends.appid = 'self sale - internet new pack';
        webTrends.TI = 'self sale - internet new pack';
        webTrends.new_cust_ind = 0;
        break;
      }
      case EntryEnum.ExistPack: {
        webTrends.appid_av = 'self sale - internet exist pack';
        webTrends.appid = 'self sale - internet exist pack';
        webTrends.TI = 'self sale - internet exist pack';
        webTrends.new_cust_ind = 1;
        break;
      }
      case EntryEnum.Cpo: {
        const isExistingCustomerVal = this.storageService.getIsExistingCustomer();
        webTrends.appid_av = `self sale - line ${isExistingCustomerVal ? 'exist' : 'new'} customer`;
        webTrends.appid = `self sale - line ${isExistingCustomerVal ? 'exist' : 'new'} customer`;
        webTrends.TI = `self sale - line ${isExistingCustomerVal ? 'exist' : 'new'} customer`;
        webTrends.new_cust_ind = isExistingCustomerVal ? 1 : 0;
        break;
      }
      case EntryEnum.Relocation: {
        webTrends.appid_av = 'self sale - internet moving customer';
        webTrends.appid = 'self sale - internet moving customer';
        webTrends.TI = 'self sale - internet moving customer';
        webTrends.new_cust_ind = 1;
        break;
      }
      case EntryEnum.Elct: {
        const isExistingCustomerVal = this.storageService.getIsExistingCustomer();
        webTrends.appid_av = 'b_elect';
        webTrends.appid = 'b_elect';
        webTrends.TI = 'b_elect';
        webTrends.new_cust_ind = isExistingCustomerVal === true
          ? 1 : isExistingCustomerVal === false
          ? 0 : undefined;
        webTrends.stage_desc = webTrends.action;
        data.vas = this.storageService.getElctSelectedCampaignTitleAndDiscount()
        data.x_param = this.storageService.getCustomerHasSmartMeter() ? 'new cous' : 'basic'
        data.id_number = webTrends.id_number || this.storageService.getSessionValue('identityNumber')
        data.phone_number = webTrends.phone_number || this.storageService.getCustomerPhoneNumber()
        break;
      }
    }

    webTrends.action = data.action || null;
    webTrends.stage_code = this.storageService.getOriginalEntry();
    webTrends.stage_status = data.stage_status || null;
    webTrends.errorMsg = data.errorMsg || null;
    webTrends.errormsg_desc = data.errormsg_desc || null;
    webTrends.verification_mode = data.verification_mode || null;
    webTrends.hativa_pratit = data.HativaPratit || null;
    webTrends.x_param_name = data.x_param_name || this.storageService.getUpdatedCampaignCode() || this.storageService.getCampaignCode() || null;
    //webTrends.x_param = data.x_param || null;
    // webTrends.activity_number = data.activity_number || null;
    webTrends.phone_number = data.phone_number || null;
    webTrends.id_number = data.id_number || null;
    webTrends.full_name = data.fullName || null;
    webTrends.email = data.email || null;
    webTrends.city = data.city || null;
    webTrends.street = data.street || null;
    webTrends.street_number  = data.street_number || null;
    webTrends.vas  = data.vas || null;
    webTrends.amount = data.amount || null;
    webTrends.x_param = data.x_param || this.storageService.getCampaignSpeed() || null;
    webTrends.locationֹ_process = this.storageService.getCampaignCode() || null;

    this.reportWT(webTrends);
  }

  isMobile() {
    return window.innerWidth < 768;
  }

  reportWT(data: WebTrendsObject) {
    this._tag.dcsVar();
    const _webTrendsLoaded = (typeof WebTrends !== 'undefined');

    if (_webTrendsLoaded) {

      data.channel = this.isMobile() ? 'Mobile' : 'Web';
      data.setDateTime();

      // Uncomment to debug Web Trends sending
      // console.log(`=== Web Trends EVENT: ${data.action} ===`);
      // console.log(data);

      const reportList = [];

      for (const key in data) {
        if (data.hasOwnProperty(key) && data[key] != null) {
          reportList.push('"WT.' + key + '"', '"' + stripHtml(data[key]) + '"');
        }
      }

      const reportString = reportList.join(',');

      const script = 'dcsMultiTrack(' + reportString + ')';

      // tslint:disable-next-line:no-eval

      try
      {
        eval(script);
      }
      catch (ex){
        console.log(ex);
      }

    }

    function stripHtml(html) {
      const tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    }
  }
}
